import React from 'react';
import styled from 'styled-components';
import { StaticImage } from 'gatsby-plugin-image';

const Branding = ({ className }) => (
  <span className={className}>
    <Brand>
      <StaticImage height={32} alt="bovag" src="./bovag.png" />
    </Brand>
    <Brand>
      <StaticImage height={32} alt="duurzaam repareren" src="./duurzaam-footer.png" />
    </Brand>
    <Brand>
      <StaticImage height={32} alt="erkend duurzaam" src="./erkend.png" />
    </Brand>
    <Brand>
      <StaticImage height={32} alt="RDC" src="./rdc.png" />
    </Brand>
    <Brand>
      <StaticImage height={32} alt="RDW" src="./rdw.png" />
    </Brand>
    <Brand>
      <StaticImage height={32} alt="James autoservice" src="./james.png" />
    </Brand>
  </span>
);

const Brand = styled.span`
  padding-right: .5rem;
  padding-left: .5rem;

  @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
    padding-right: 1rem;
    padding-left: 0;
  }
`;

export default styled(Branding)`
  margin-bottom: .5rem;
  display: flex;
  align-items: center;
  justify-content: center;

  @media all and (min-width: ${({ theme }) => theme.breakingpoints.lg}) {
    margin-bottom: 0;
  }

  img {
    display: block;
    max-height: 32px;
  }
`;
